import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentLeftBar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlignmentLeftBar"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 4V20H2V4H3.5ZM7 5.5H22V7H7V5.5ZM7 11.25H22V12.75H7V11.25ZM7 17H17V18.5H7V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignmentLeftBar;
